import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import axios from 'axios';
import ElementPlus from 'element-plus';
import * as ElIconModules from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'; // 确保引入 Element Plus 样式
import '@vueup/vue-quill/dist/vue-quill.snow.css';  // 引入编辑器的样式
import { QuillEditor } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.core.css'
import '@vueup/vue-quill/dist/vue-quill.bubble.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'dayjs/locale/zh-cn' // 必须导入

// 设置 Axios 基础 URL
axios.defaults.baseURL = process.env.VUE_APP_API_URL; // 使用环境变量

const app = createApp(App);// 全局配置Element Plus中文
app.use(ElementPlus, {
    locale: zhCn,
})

// 设置全局属性
app.config.globalProperties.$axios = axios;

// 配置自定义元素
app.config.compilerOptions.isCustomElement = (tag) => {
    return ['el-dialog', 'el-form', 'el-form-item', 'el-list', 'el-list-item'].includes(tag);
};
// 注册所有图标
for (const [key, component] of Object.entries(ElIconModules)) {
    app.component(key, component)
}
// 使用路由和 Element Plus
app.use(router);
app.use(ElementPlus);
app.use(QuillEditor)

// 挂载应用
app.mount('#app');
